import { PapiDeviation } from '@wix/da-papi-types';
import React from 'react';
import Timestamp from '../../../Timestamp';
import UserAvatar from '../../../User/Avatar';
import BasicUserName from '../../../User/BasicUserName';
import UserLink from '../../../User/Link';
import s from './FooterPanel.scss';

export const FOOTER_PANEL_HEIGHT = parseInt(s['footer-panel-height'], 10);

export interface Props {
  deviation: PapiDeviation;
  withAuthorLink?: boolean;
}

const FooterPanel: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  withAuthorLink = true,
}) => {
  const author = deviation.author && (
    <>
      <UserAvatar user={deviation.author} size={24} className={s['avatar']} withLink={false} />
      <span className={s['username']}>
        <BasicUserName user={deviation.author} />
      </span>
    </>
  );

  return (
    <div className={s['root']}>
      {deviation.author &&
        (withAuthorLink ? (
          <UserLink user={deviation.author} className={s['author']}>
            {author}
          </UserLink>
        ) : (
          <span className={s['author']}>{author}</span>
        ))}
      <Timestamp timestamp={deviation.publishedTime} className={s['timestamp']} />
    </div>
  );
};
FooterPanel.displayName = 'FooterPanel';

export default FooterPanel;
